module.exports = __webpack_public_path__ + "static/media/landing-like-posts.ed8cef40.png";